import { render, staticRenderFns } from "./AreaVertexCoordinates.vue?vue&type=template&id=aba6d162&scoped=true&"
import script from "./AreaVertexCoordinates.vue?vue&type=script&lang=js&"
export * from "./AreaVertexCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./AreaVertexCoordinates.vue?vue&type=style&index=0&id=aba6d162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba6d162",
  null
  
)

export default component.exports